import styled from 'styled-components';
interface P1Props {
	'data-test-id'?: string;
}

const P1 = styled.p<P1Props>`
	font-weight: normal;
	font-size: 1.4rem;
	line-height: 175%;
	margin: 0;
	font-style: normal;
	color: black;
`;

export default P1;
